import { QuestionnaireFormData } from '@/features/questionnaires/types/questionnaire.interface';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NumberInput } from '@/shared';

type VoiceQuestionParametersProps = {
  questionIndex: number;
};

export const VoiceQuestionParameters = ({
  questionIndex,
}: VoiceQuestionParametersProps) => {
  const { t } = useTranslation();
  const form = useFormContext<QuestionnaireFormData>();

  return (
    <NumberInput
      form={form}
      name={`questions.${questionIndex}.parameters.maxDurationSeconds`}
      label={t('pages.studies.questions.voiceParameters.maxDurationSeconds')}
      sx={{ mt: 1 }}
    />
  );
};
